// Application JavaScript entry point
// Using ES modules for esbuild

import './application/main';

import Rails from 'rails-ujs';

// Initialize Rails UJS
if (!window._rails_loaded) {
  Rails.start();
}

// Import application modules
import './application/shared/global';
import './application/shared/header';
import './application/shared/confirm';

// Import controllers
import './application/controllers/faqs/index';
import './application/controllers/orders/index';
import './application/controllers/orders/products';
import './application/controllers/orders/payment';
import './application/controllers/pages/show';
